import { h } from '@stencil/core';
import cn from 'classnames';
import { pesIconSizes } from '@pes-ui/utils';
export class IconTooltipComponent {
  constructor() {
    this.handleTooltipOpen = () => {
      this.active = true;
      this.didOpen.emit();
    };
    this.handleTooltipClose = () => {
      this.active = false;
      this.didClose.emit();
    };
    this.icon = 'information_circle';
    this.iconColor = 'blue';
    this.iconSize = pesIconSizes.SMALL;
    this.position = 'bottom';
    this.text = undefined;
    this.active = false;
    this.host.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const iconClass = cn('tooltip-icon', `icon-color-${this.iconColor}`, { active: this.active });
    return (h("pes-tooltip-wrapper", { onDidOpen: this.handleTooltipOpen, onDidClose: this.handleTooltipClose, position: this.position }, h("div", { slot: "tooltip-activator", class: "tooltip-label-container" }, h("pes-icon", { class: iconClass, size: this.iconSize }, this.icon), this.text && h("span", { class: "tooltip-text" }, this.text)), h("div", { slot: "tooltip-content" }, h("slot", null))));
  }
  static get is() { return "pdp-icon-tooltip"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["tooltip.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["tooltip.css"]
    };
  }
  static get properties() {
    return {
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'information_circle' | 'information_stroke'",
          "resolved": "\"information_circle\" | \"information_stroke\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon",
        "reflect": false,
        "defaultValue": "'information_circle'"
      },
      "iconColor": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'blue' | 'grey'",
          "resolved": "\"blue\" | \"grey\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-color",
        "reflect": false,
        "defaultValue": "'blue'"
      },
      "iconSize": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TIconSize",
          "resolved": "\"large\" | \"medium\" | \"micro\" | \"nano\" | \"small\" | \"xlarge\"",
          "references": {
            "TIconSize": {
              "location": "import",
              "path": "../pes-icon/icon"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-size",
        "reflect": false,
        "defaultValue": "pesIconSizes.SMALL"
      },
      "position": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'top' | 'bottom'",
          "resolved": "\"bottom\" | \"top\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "position",
        "reflect": false,
        "defaultValue": "'bottom'"
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Info icon label"
        },
        "attribute": "text",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "active": {}
    };
  }
  static get events() {
    return [{
        "method": "didOpen",
        "name": "didOpen",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "didClose",
        "name": "didClose",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "host"; }
}
